import React, { createContext, useReducer, Dispatch } from "react";
import { WidgetConfig } from "./types/WidgetConfig";

export interface WidgetStateActions {
  type: string;
  value?: any;
}

export interface WidgetState {
  isPopupOpen: boolean;
  config: WidgetConfig;
  clientId: number;
  toast?: string;
}

export interface WidgetContextProps {
  state: WidgetState;
  dispatch: Dispatch<WidgetStateActions>;
}

export const WidgetContext = createContext({} as WidgetContextProps);

const reducer = (state: WidgetState, action: any) => {
  const { type, value } = action;

  switch (type) {
    case "set": {
      return { ...state, ...value };
    }
  }
  return state;
};

export const WidgetContextProvider = ({ initial, children }: any) => {
  const initialState: WidgetState = {
    isPopupOpen: false,
    ...(initial ?? {})
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <WidgetContext.Provider value={{ state, dispatch } as WidgetContextProps}>
      {children}
    </WidgetContext.Provider>
  );
};

export const WidgetContextConsumer = WidgetContext.Consumer;
